import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n';
import type { JSX, ReactNode } from 'react';

import './HowToOrderASubscription.scss';

const FeatureBox = ({ title, description }: { title: string; description: ReactNode }): JSX.Element => (
  <div className={`${dsClass.BACKGROUND_COLOR_NEUTRAL_200} of-how-to-order-a-subscription__numbered-feature-box`}>
    <h3 className="of-how-to-order-a-subscription__numbered-feature-box__header">{title}</h3>
    <p className={dsClass.TEXT_S}>{description}</p>
  </div>
);

export const BenefitsOf5GSubscription = (): JSX.Element => {
  const benefits = [
    {
      title: t.R7AY('Better battery life'),
      description: t.M39B(
        `Aito 5G can reduce your device’s battery consumption by up to 20% compared to a standard 4G or 5G subscription`
      ),
    },
    {
      title: t.BOZA('More stable connection'),
      description: t.U3PR(
        `Enjoy smoother internet performance and more reliable remote meetings without video interruptions or dropped connections.`
      ),
    },
    {
      title: t.QM6C('Performs even in crowded networks'),
      description: t.U6SB(
        'Aito 5G delivers the best performance in all situations, including high-traffic environments such as large events where the network is congested.'
      ),
    },
    {
      title: t.Z3ZW('Clear and natural voice quality'),
      description: t.FNBG(
        `improved voice quality makes conversations sound more natural and reduces distracting background noise.`
      ),
    },
  ];

  return (
    <section className="of-how-to-order-a-subscription of-how-to-order-a-subscription--5g">
      <h2>
        {t.QY8T(
          `Elisa’s Aito 5G is the most advanced network technology, delivering concrete benefits for your business`
        )}
      </h2>
      <div className="of-how-to-order-a-subscription__grid">
        {benefits.map(item => (
          <FeatureBox key={item.title} title={item.title} description={item.description} />
        ))}
      </div>
    </section>
  );
};
